import React, { Fragment } from "react";
import { Row, Col } from "reactstrap";
import AdminContain from "../../../Component/Admin/Admin/AdminContain";

const Admins = () => {
	return (
		<Fragment>
			<Col xl="12" className="xl-80">
				<Row>
					<AdminContain />
				</Row>
			</Col>
		</Fragment>
	);
};
export default Admins;
